<template>
  <v-dialog v-model="showDialog" max-width="500px">
    <v-card>
      <v-card-title><h1>Delete Teammate</h1></v-card-title>
      <v-divider />
      <v-card-text>
        <div class="text-h6">
          Do you really want to delete this teammate?
          <br />
          <h3 v-if="teammateToDelete" class="mt-2">
            {{ teammateToDelete.email }}?
          </h3>
          <br />
          All stores created by this account will be deleted.
          <br />
          This action cannot be undone.
        </div>
      </v-card-text>
      <v-card-actions class="py-3 px-3">
        <v-btn
          color="primary"
          class="text-white"
          variant="flat"
          @click="handleCancel"
        >
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn variant="flat" @click="handleDelete" data-testid="confirm-delete-order">
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/mixins/rules";
import helpers from "@/mixins/helpers";
import moment from "moment";
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "DeleteTeammateDialog",

  props: {},
  computed: {},

  data() {
    return {
      showDialog: false,
      teammateToDelete: null,
    };
  },
  mounted() {},
  methods: {
    show(teammate) {
      this.teammateToDelete = teammate;
      this.showDialog = true;
    },

    handleCancel() {
      this.showDialog = false;
    },

    handleDelete() {
      this.$emit("delete-teammate", this.teammateToDelete);
      this.showDialog = false;
    },
  },
};
</script>
<style scope></style>
